export const formData = {
	id: '',
	attributes: [],
	confirmationButton: {
		affirmativeText: 'Yes',
		confirmationMessage: 'Are you sure you want to submit the form?',
		confirmationText: 'Submit',
		negativeText: 'No',
	},
	identificationType: 'NO_AUTH',
	skipButton: null,
	skipLogin: null,
	subtitle: '',
	title: '',
	showConfirmationBox: true,
};
